import { betterAuth } from "better-auth";
import { drizzleAdapter } from "better-auth/adapters/drizzle";
import { db } from "../db/index";
import { users } from "../db/schema/identity";
import { session, account, verification } from "../db/schema/auth";
import { env } from "../lib/env";

/**
 * Better Auth (self-hosted) — sessions + email/password. Replaces Laravel Fortify/Sanctum.
 * The `user` model is mapped onto the legacy `users` table; session/account/verification are
 * BA-owned (schema/auth.ts). `useNumberId` → numeric auto-increment ids (matches users.id int).
 * The scoped RBAC layer (reskin-docs/03) sits on top; BA owns only identity/session.
 * Legacy bcrypt `users.password` values are NOT used by BA (credentials live in `account`);
 * migrating them is a separate data task — new credentials are created via the admin/employee flow.
 */
export const auth = betterAuth({
  baseURL: env.BETTER_AUTH_URL,
  secret: env.BETTER_AUTH_SECRET,
  database: drizzleAdapter(db, {
    provider: "mysql",
    schema: { user: users, session, account, verification },
  }),
  emailAndPassword: { enabled: true, requireEmailVerification: false },
  // numeric auto-increment ids: BA omits the id on insert, MySQL assigns it (matches users.id int)
  advanced: { database: { generateId: false } },
  trustedOrigins: env.FRONTEND_ORIGIN.split(",").map((o) => o.trim()),
});

export type Auth = typeof auth;
